const requiredEnv = (name, value) => {
  if (!value) throw new Error(`Missing required environment variable: ${name}`);
  return value;
};

export const config = {
  API_URL: `${requiredEnv('REACT_APP_BACKEND_URL', process.env.REACT_APP_BACKEND_URL)}/api`,
  FIREBASE: {
    apiKey: requiredEnv('REACT_APP_FIREBASE_API_KEY', process.env.REACT_APP_FIREBASE_API_KEY),
    authDomain: requiredEnv('REACT_APP_FIREBASE_AUTH_DOMAIN', process.env.REACT_APP_FIREBASE_AUTH_DOMAIN),
    projectId: requiredEnv('REACT_APP_FIREBASE_PROJECT_ID', process.env.REACT_APP_FIREBASE_PROJECT_ID),
    storageBucket: requiredEnv('REACT_APP_FIREBASE_STORAGE_BUCKET', process.env.REACT_APP_FIREBASE_STORAGE_BUCKET),
    messagingSenderId: requiredEnv('REACT_APP_FIREBASE_MESSAGING_SENDER_ID', process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID),
    appId: requiredEnv('REACT_APP_FIREBASE_APP_ID', process.env.REACT_APP_FIREBASE_APP_ID),
    databaseURL: requiredEnv('REACT_APP_FIREBASE_DATABASE_URL', process.env.REACT_APP_FIREBASE_DATABASE_URL)
  }
};

export default config;
